import {DESK_SETTING, DOCS} from './endpoint'
import {
  ADD_SURVEY,
  GET_SURVEY,
  DELETE_SURVEY,
  GET_SURVEY_LIST,
  EDIT_SURVEY,
  ADD_SLA,
  GET_SLA,
  DELETE_SLA,
  GET_SLA_LIST,
  EDIT_SLA,
  EDIT_SLA_STATUS,
  GET_TRAIL_LOGS_KB,
} from './types'
import {apiAction} from './api'

export function addSurvey(data) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/surveys`,
    method: 'POST',
    label: ADD_SURVEY,
    data,
    showToast: true,
    successMessage: 'Survey Created',
  })
}

export function editSurvey(id, data, isStatus = false) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/surveys/${id}${isStatus ? '/status' : ''}`,
    method: 'PUT',
    label: EDIT_SURVEY,
    data,
    showToast: true,
    successMessage: 'Survey Updated',
  })
}

export function deleteSurvey(id) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/surveys/${id}`,
    method: 'DELETE',
    label: DELETE_SURVEY,
    showToast: true,
    successMessage: 'Survey Deleted',
  })
}

export function getSurvey(id) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/surveys/${id}`,
    method: 'GET',
    label: GET_SURVEY,
  })
}

export function getSurveyList() {
  return apiAction({
    url: `${DESK_SETTING}/productivity/surveys`,
    method: 'GET',
    label: GET_SURVEY_LIST,
  })
}

// SLA Policy --------------------------->

export function addSLAPolicy(data) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla`,
    method: 'POST',
    label: ADD_SLA,
    data,
    showToast: true,
    successMessage: 'SLA Management Created',
  })
}

export function changeStatusSLAPolicy(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla/${id}/status`,
    method: 'PUT',
    label: EDIT_SLA_STATUS,
    data,
    showToast: true,
    successMessage: 'SLA Management Status Updated',
  })
}

export function editSLAPolicy(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla/${id}`,
    method: 'PUT',
    label: EDIT_SLA,
    data,
    showToast: true,
    successMessage: 'SLA Management Updated',
  })
}

export function deleteSLAPolicy(id) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla/${id}`,
    method: 'DELETE',
    label: DELETE_SLA,
    showToast: true,
    successMessage: 'SLA Management Deleted',
  })
}

export function getSLAPolicy(id) {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla/${id}`,
    method: 'GET',
    label: GET_SLA,
  })
}

export function getSLAPolicyList() {
  return apiAction({
    url: `${DESK_SETTING}/productivity/sla`,
    method: 'GET',
    label: GET_SLA_LIST,
  })
}

export function getTrailLogKnowledgebase(data) {
  return apiAction({
    url: `${DOCS}/qa-audit/trail-logs`,
    method: 'POST',
    label: GET_TRAIL_LOGS_KB,
    data,
  })
}
